import { ReducerBuilder } from './ReducerBuilder'

const dummyReducers = {}

// These should represent the initial states of each part of the state when the app loads
// If a reducer is added, move to own file
const initialStates = {
  errors: [],
  preview: {},
  ingSubscription: {
    subscriptionPage: 0,
  },
}

Object.keys(initialStates).forEach((key) => (dummyReducers[key] = ReducerBuilder.create(initialStates[key]).build()))

export default dummyReducers
